import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import CustomButton from "../../../UIElements/CustomButton";
import { SignUpContext } from "../../../../contexts";
import "../../../components-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { phoneRegExp, emailRegExp } from "../../../../consts";
import InputField from "../../../UIElements/InputField";
import { checkIfUserEmailExists } from "../../../../services";

type UserContactFormProps = {
    goto: (step: number) => void;
    nextStep: number;
};

const validationSchema = yup.object({
    email: yup
        .string()
        .required("Veuillez renseigner une adresse email")
        .email("Veuillez renseigner une adresse email valide")
        .matches(emailRegExp)
        .test(
            "checkIfUserEmailExists",
            "Cette adresse e-mail est déjà associée à un autre compte.",
            async (value) => {
                await yup.string().email().matches(emailRegExp).validate(value);
                if (value) {
                    const userEmailExistsRes = await checkIfUserEmailExists(
                        value
                    );
                    return userEmailExistsRes.status === 200 ? false : true;
                }
                return true;
            }
        ),
    phoneNumber: yup
        .string()
        .matches(
            phoneRegExp,
            "Veuillez renseigner un numéro de téléphone valide"
        )

        .required("Veuillez renseigner un numéro de téléphone"),
});

export default function UserContactForm({
    goto,
    nextStep,
}: UserContactFormProps) {
    const { updateSignupForm, ...signupForm } = useContext(SignUpContext);
    const { signupUser } = signupForm;

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            email: signupUser?.email ?? "",
            phoneNumber: signupUser?.phoneNumber ?? "",
        },
        resolver: yupResolver(validationSchema),
    });

    const onSubmit = async (data: any) => {
        updateSignupForm({
            ...signupForm,
            step: nextStep,
            signupUser: {
                ...signupForm.signupUser,
                ...data,
            },
        });
        goto(nextStep);
    };

    return (
        <Box className="signup-form-root">
            <Box className="signup-form-title-container">
                <Typography className="signup-form-title">
                    {"Moyen de contact de votre établissement "}
                </Typography>
            </Box>

            <form onSubmit={handleSubmit(onSubmit)} className="signup-form">
                <Controller
                    name="email"
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <InputField
                            label={"Adresse email *"}
                            sublabel="Cette adresse mail sera celle qui vous permetta de vous connecter à votre compte SOCOTEC"
                            fullWidth
                            {...others}
                            errortext={
                                errors.email?.message
                                    ? errors.email?.message
                                    : ""
                            }
                        />
                    )}
                />
                <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <InputField
                            label={"Numéro de téléphone *"}
                            fullWidth
                            inputProps={{
                                type: "tel",
                                maxLength: 10,
                            }}
                            {...others}
                            errortext={errors.phoneNumber?.message ?? ""}
                        />
                    )}
                />

                <CustomButton
                    type="submit"
                    label="Étape suivante"
                    customsx={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: "3.5rem",
                        marginBottom: "auto",
                    }}
                />
            </form>
        </Box>
    );
}
